import React from 'react'
import ImageComponent from './image'
import Link from 'gatsby-link'

export default class SectionRegisterComponent extends React.Component {
    constructor(props) {
        super()
        this.state = props
    }
    loadRegister() {
        typeof window !== 'undefined' && ( window.location.href = '/register/')
    }

    render() {
        return (
            <div className="section--fourth" id="register">
                <div className="section__grid">
                    <div className="section__text">
                        <h2>Register</h2>
                        <p>Register now for the event (limited tickets are available).<br />The ticket will include the conference material, lunches and coffee breaks.</p>
                        <p>If you are funded/waged for your studies/job, or if you received a grant for participating to this conference: <strong>25€</strong><br />If you are unfunded/unwaged and did not receive any grant: <strong>20€</strong></p>
                    </div>
                    <div className="section__text u-text-center">
                        <div className="u-text-center">
                            <p className="c-grid--thirds">
                                <ImageComponent class="c-column-offset" image="stylus" />
                            </p>
                            <p>
                                <button className="c-btn--fourth" onClick={this.loadRegister}>Register now</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/section-register.js